// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__orNcv","box":"Modal_box__KwgIm","close":"Modal_close__GqIjb","hidden":"Modal_hidden__tKLM3"};